import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  Grid,
  Button
} from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Topbar from "../global/Topbar";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

function ItemSubGroupMaster(props) {
  const [ItemSubGroups, setItemSubGroups] = useState([]);
  const [ItemSubGroupCode, setItemSubGroupCode] = useState('');
  const [ItemSubGroupName, setItemSubGroupName] = useState('');
  const [ItemSubGroupNameEnglish, setItemSubGroupNameEnglish] = useState('');
  const [ItemMainGroupCode, setItemMainGroupCode] = useState('');
  const [formMode, setFormMode] = useState('add');
  const [editItemSubGroupCode, setEditItemSubGroupCode] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [ItemSubGroupMasterEntries, setItemSubGroupMasterEntries] = useState([]);

  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  
  useEffect(() => {
    fetchItemSubGroupMaster();
  }, []);

  const fetchItemSubGroupMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/itemSubGroups');
      // Ensure response.data is an array before setting the state
      if (Array.isArray(response.data)) {
        setItemSubGroupMasterEntries(response.data);
        const maxEntryNo = calculateMaxEntryNo(response.data);
        const nextEntryNo = maxEntryNo + 1; 
        setItemSubGroupCode(nextEntryNo);
      } else {
        console.error('Received data is not an array:', response.data);
      }
    } catch (error) {
      console.log('error:', error);
    }
  };

  
  const calculateMaxEntryNo = (entries) => {
  let maxEntryNo = 0;
  for (const entry of entries) {
  if (entry.ItemSubGroupCode > maxEntryNo) {
  maxEntryNo = entry.ItemSubGroupCode;
  }
  }
  return maxEntryNo;
  };

  const addItemSubGroup = async () => {
    try {
      await axios.post('https://www.wingap.net.in/api/itemSubGroups', {
        ItemSubGroupCode: ItemSubGroupCode,
        ItemSubGroupName: ItemSubGroupName,
        ItemSubGroupNameEnglish: ItemSubGroupNameEnglish,
        ItemMainGroupCode: ItemMainGroupCode,
        USERID: props.name
      });
      fetchItemSubGroupMaster();
      setItemSubGroupCode('');
      setItemSubGroupName('');
      setItemSubGroupNameEnglish('');
      setItemMainGroupCode('');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateItemSubGroup = async (ItemSubGroupCode) => {
    try {
      await axios.put(`https://www.wingap.net.in/api/itemSubGroups/${ItemSubGroupCode}`, {
        ItemSubGroupName: ItemSubGroupName,
        ItemSubGroupNameEnglish: ItemSubGroupNameEnglish,
        ItemMainGroupCode: ItemMainGroupCode,
      });
      fetchItemSubGroupMaster();
      setItemSubGroupCode('');
      setItemSubGroupName('');
      setItemSubGroupNameEnglish('');
      setItemMainGroupCode('');
      setFormMode('add');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const deleteItemSubGroup = async (ItemSubGroupCode) => {
    try {
       const response = await axios.delete(`https://www.wingap.net.in/api/itemSubGroups/${ItemSubGroupCode}`, {
        headers: {
          'username': props.name,
        },
      });
      if (response.status === 200) {
        fetchItemSubGroupMaster();
      }
    } catch (error) {
      console.log('Error:', error);

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    // Reset the error message
    setErrorMessage('');
  };  

  const setEditForm = (ItemSubGroup) => {
    setFormMode('edit');
    setItemSubGroupCode(ItemSubGroup.ItemSubGroupCode);
    setItemSubGroupName(ItemSubGroup.ItemSubGroupName);
    setItemSubGroupNameEnglish(ItemSubGroup.ItemSubGroupNameEnglish);
    setItemMainGroupCode(ItemSubGroup.ItemMainGroupCode);
    setShowGrid(false);
  };

  const handleSearch = (searchQuery) => {
    const filtered = ItemSubGroups.filter((ItemSubGroup) => {
      const ItemSubGroupCode = ItemSubGroup.ItemSubGroupCode.toString().toLowerCase();
      const ItemSubGroupName = ItemSubGroup.ItemSubGroupName.toString().toLowerCase();
      const ItemSubGroupNameEnglish = ItemSubGroup.ItemSubGroupNameEnglish.toString().toLowerCase();
      const ItemMainGroupCode = ItemSubGroup.ItemMainGroupCode.toString().toLowerCase();

      return (
        ItemSubGroupCode.includes(searchQuery.toLowerCase()) ||
        ItemSubGroupName.includes(searchQuery.toLowerCase()) ||
        ItemSubGroupNameEnglish.includes(searchQuery.toLowerCase()) ||
        ItemMainGroupCode.includes(searchQuery.toLowerCase())
      );
    });

    setItemSubGroupMasterEntries(filtered);
  };

  useEffect(() => {
    handleSearch(props.searchQuery);
  }, [props.searchQuery, ItemSubGroups]);

  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    setItemSubGroups(ItemSubGroups);
  };

  const handleCancel = () => {
    setFormMode('add');
    setEditItemSubGroupCode('');
    setItemSubGroupCode('');
    setItemSubGroupName('');
    setItemSubGroupNameEnglish('');
    setItemMainGroupCode('');
    fetchItemSubGroupMaster();
  };

  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "ItemSubGroupData",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }
        
        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>ItemSubGroupMaster</h1>
      <Grid item>
        <Button
          variant="contained"
          className="view-button"
          onClick={handleshowandhide}
          sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float: 'right' }}
        >
          {showGrid ? 'Add' : 'Back'}
        </Button>
      </Grid>
      {showGrid && <Grid item>
        <Button
          variant="contained"
          onClick={generatePDF}
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Download PDF
        </Button>
      </Grid>}
      {showGrid && <Grid item>
        <Button
          variant="contained"
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Export
        </Button>
      </Grid>}
      {!showGrid && (
        <>
        <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>{formMode === 'add' ? 'Add' : 'Edit'}</h2>
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="ItemSubGroupCode" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>ItemSubGroupCode</label>
            <input
              type="text"
              id="ItemSubGroupCode"
              value={ItemSubGroupCode}
              readOnly
              placeholder="ItemSubGroupCode"
              style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="ItemSubGroupName" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>ItemSubGroupName</label>
            <input
              type="text"
              id="ItemSubGroupName"
              value={ItemSubGroupName}
              onChange={(e) => setItemSubGroupName(e.target.value)}
              placeholder="ItemSubGroupName"
              style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="ItemSubGroupNameEnglish" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>ItemSubGroupNameEnglish</label>
            <input
              type="text"
              id="ItemSubGroupNameEnglish"
              value={ItemSubGroupNameEnglish}
              onChange={(e) => setItemSubGroupNameEnglish(e.target.value)}
              placeholder="ItemSubGroupNameEnglish"
              style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="ItemMainGroupCode" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>ItemMainGroupCode</label>
            <input
              type="text"
              id="ItemMainGroupCode"
              value={ItemMainGroupCode}
              onChange={(e) => setItemMainGroupCode(e.target.value)}
              placeholder="ItemMainGroupCode"
              style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
            />
          </div>
        </div>
        <div>
          <button
            className={formMode === 'add' ? 'add-button' : 'update-button'}
            onClick={formMode === 'add' ? addItemSubGroup : () => updateItemSubGroup(ItemSubGroupCode)}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginBottom: '10px',
            }}
          >
            {formMode === 'add' ? 'Add' : 'Update'}
          </button>
          <button
            className="view-button"
            onClick={handleCancel}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginLeft: '10px',
              marginBottom: '10px',
            }}
          >
            Cancel
          </button>
        </div>
      </>      
      )}
      {showGrid && (
        <div ref={componentPDF} style={{ width: '100%' }}>
          <h2>Entries</h2>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              border: '1px solid #ccc',
            }}
          >
            <thead>
              <tr style={{ background: '#f2f2f2', color: 'black' }}>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  ItemSubGroupCode
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  ItemSubGroupName
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  ItemSubGroupNameEnglish
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  ItemMainGroupCode
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                  className="print-hide"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
            {Array.isArray(ItemSubGroupMasterEntries) && ItemSubGroupMasterEntries.map((ItemSubGroup)  => (
                <tr key={ItemSubGroup.ItemSubGroupCode} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{ItemSubGroup.ItemSubGroupCode}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{ItemSubGroup.ItemSubGroupName}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{ItemSubGroup.ItemSubGroupNameEnglish}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{ItemSubGroup.ItemMainGroupCode}</td>
                  <td className="print-hide">
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(76, 175, 80)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        marginRight: '5px',
                        marginLeft: '10px',
                      }}
                      onClick={() => setEditForm(ItemSubGroup)}
                    >
                      Edit
                    </button>
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(244, 67, 54)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                      onClick={() => deleteItemSubGroup(ItemSubGroup.ItemSubGroupCode)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center'}} // Center the Snackbar
      >
        <MuiAlert elevation={6} variant="filled" severity="error" sx={{fontSize:'16px'}} onClose={handleCloseSnackbar}>
          {errorMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}

export default ItemSubGroupMaster;
